export default function StatCard({
  label,
  value,
  icon,
  cardClass = '',
  valueClass = '',
  onClick,
  clickable = Boolean(onClick),
}) {
  const isInteractive = clickable && typeof onClick === 'function';

  const handleKeyDown = (e) => {
    if (!isInteractive) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onClick={isInteractive ? onClick : undefined}
      onKeyDown={handleKeyDown}
      className={`rounded-xl border px-4 py-4 bg-white ${cardClass} ${
        isInteractive
          ? 'cursor-pointer transition-shadow hover:shadow-md hover:ring-2 hover:ring-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500/40'
          : ''
      }`}
    >
      <div className="text-sm text-gray-500">{label}</div>
      <div className={`mt-2 flex items-center gap-2 text-2xl font-bold ${valueClass}`}>
        <span className="text-lg opacity-90">{icon}</span>
        <span>{value}</span>
      </div>
    </div>
  );
}
